import { Validator } from '@vista-digital/validator';
import { defaultEventDescriptionConfig, eventDescriptionConfigValidator } from './config';
import { defaultEventDescriptionDisplayText, eventDescriptionDisplayTextValidator } from './display-text';
export const defaultEventDescriptionProps = {
    displayText: defaultEventDescriptionDisplayText,
    config: defaultEventDescriptionConfig
};
export const eventDescriptionPropsValidator = Validator.object({
    displayText: eventDescriptionDisplayTextValidator,
    config: eventDescriptionConfigValidator
});
